import { render, staticRenderFns } from "./reg.vue?vue&type=template&id=b76e10ac&scoped=true"
import script from "./reg.vue?vue&type=script&lang=js"
export * from "./reg.vue?vue&type=script&lang=js"
import style0 from "./reg.vue?vue&type=style&index=0&id=b76e10ac&prod&lang=scss"
import style1 from "./reg.vue?vue&type=style&index=1&id=b76e10ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b76e10ac",
  null
  
)

export default component.exports